// removed by extract-text-webpack-plugin
module.exports = {"unit":"5px","colorWhite":"#ffffff","colorGuidanceCategoryBackground":"#eae9e8","h5":"fonts__h5____3jyVL","container":"guidance-category__container____2dZ2f","title":"guidance-category__title____2V_-6 fonts__h5____3jyVL","content":"guidance-category__content____3Dq9t"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/components/guidance-category/guidance-category.css
// module id = 693
// module chunks = 0